import { baseSearchObject } from "nsitools-react";
import * as React from "react";

import {
  PaginatedSearch,
  ReferentialApi,
  SearchDogReferentialQuery,
} from "../api";
import { PageBase, SmallFormGenerator } from "../components";
import { FGAdvancedSearchInput } from "../components";
import { useApiService } from "../hooks";

export interface ITestDevPageProps {}

export const TestDevPage: React.FunctionComponent<ITestDevPageProps> = (
  props
) => {
  const saveItem = React.useCallback((data: any) => {
    console.log("saved", data);
  }, []);

  const refApi = useApiService(ReferentialApi);

  const searchFn = React.useCallback(
    async (sObj: baseSearchObject) =>
      refApi.searchDogs(
        new SearchDogReferentialQuery({ sObj: PaginatedSearch.fromJS(sObj) })
      ),
    [refApi]
  );

  const getDisplayedDataFn = React.useCallback(
    async (id: any) => {
      const d = await refApi.searchDogs(
        new SearchDogReferentialQuery({ dogId: +id })
      );
      return d.results.length > 0 ? d.results[0] : null;
    },
    [refApi]
  );

  return (
    <PageBase breadCrumbs={[{ text: "TEST-DEVS" }]}>
      <SmallFormGenerator
        initialValues={{ dogId: 12206665 }}
        onSubmit={saveItem}
        editMode={true}
        fill={true}
        debug={true}
      >
        <FGAdvancedSearchInput
          name="dogId"
          label="Chien"
          searchFn={searchFn}
          getDisplayedDataFn={getDisplayedDataFn}
          showTableHeader={true}
          columns={[
            {
              fieldName: "displayValue",
            },
            {
              fieldName: "keyValue",
            },
          ]}
        />
      </SmallFormGenerator>
    </PageBase>
  );
};
